import React from 'react';
import PropTypes from 'prop-types';
import { CTAButton } from 'shared-components/buttons/cta-button';
import classnames from 'classnames';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const CustomOfferWhatsNext = ({
  handleWithdrawOfferClick,
  redirectToInboxDetails,
  isSubmitting,
  isHostUpdate,
  intl
}) => {
  return (
    <div className="CustomOfferWhatsNext">
      <h6>
        <FormattedMessage
          id='inbox_review_offer.custom_offer_whats_next.whats'
          defaultMessage='What’s next?'
        />
      </h6>
      <div>
        { isHostUpdate
          ? intl.formatMessage({ id: 'inbox_review_offer.custom_offer_whats_next.respond_offer', defaultMessage: 'The guest will have up to 7 days to respond to your request before it expires. If it expires or gets declined, your booking will revert to the original details.' })
          : intl.formatMessage({ id: 'inbox_review_offer.custom_offer_whats_next.review_offer', defaultMessage: 'The guest has up to 7 days to review the offer. If they accept, the booking will be confirmed. If they decline or you withdraw it, you can create a new offer.' })
        }
      </div>

      <div className="cta-buttons flex">
        <CTAButton
          onClickAction={redirectToInboxDetails}
          buttonText={ intl.formatMessage({ id: 'inbox_review_offer.custom_offer_whats_next.done', defaultMessage: 'Done' }) }
          classNameString="done-button btn btn-primary"
          isDisabled={false}
        />
        <CTAButton
          onClickAction={() => { handleWithdrawOfferClick(isHostUpdate); }}
          buttonText={ intl.formatMessage({ id: 'inbox_review_offer.custom_offer_whats_next.withdraw', defaultMessage: 'Withdraw Offer' }) }
          classNameString={classnames('btn btn-gray-outline', { loading: isSubmitting })}
          isDisabled={ false }
        />
      </div>
    </div>
  );
};

CustomOfferWhatsNext.propTypes = {
  handleWithdrawOfferClick: PropTypes.func,
  redirectToInboxDetails: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isHostUpdate: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(CustomOfferWhatsNext);
